import { combineReducers } from 'redux'
import { reducer as fbtSubmissions } from 'features/fbt-submissions'
import { reducer as fbtSummary } from 'features/fbt-summary'


export default combineReducers({
  fbtSubmissions,
  fbtSummary,
})
